import styled from 'styled-components';

interface SideBarMenuItemContainerProps {
  selected?: boolean;
}

const SideBarMenuItemContainer = styled.div<SideBarMenuItemContainerProps>`
  width: 62px;
  height: 62px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${(props) => (props.selected ? `default` : `pointer`)};
`;

export default SideBarMenuItemContainer;
